import { Component, OnInit } from '@angular/core';
import * as XLSX from "xlsx";
import { WorkBook, WorkSheet, utils, read } from 'xlsx';
import { saveAs } from "file-saver";
import { ApiService } from '../../../utils/services/api.service';
import { takeWhile, expand, delay } from 'rxjs/operators';
import { ParameterService } from '../../../utils/services/parameter.service';
@Component({
  selector: 'app-system-hotels',
  templateUrl: './system-hotels.component.html',
  styleUrls: ['./system-hotels.component.css']
})
export class SystemHotelsComponent implements OnInit {

  showLoading = false;

  constructor(private apiService: ApiService, private parameterService: ParameterService) {


  }

  ngOnInit() {
  }

  exportHotels() {
    this.showLoading = true;
    let printPropertyOrders = [
      'ID',
      'Otel adı',
      'Yıldızı',
      'Adresi',
      'Şehir',
      'Ülke kodu',
      'Telefon',
      'Rezervasyon bölümü e mail adresi',
      'Oda tipi',
      'Konaklama tipi',
      'Oda açıklaması',
      'Fiyat başlangıç tarihi',
      'Fiyat bitiş tarihi',
      'Ödeme tipi',
      'Ödeme kanalı',
      'Para birimi',
      'Satış tutarı',
      'Hizmet bedeli tutarı',
      'Alış tutarı',
      'Komisyon tutarı'
    ];
    this.apiService.getSystemHotels('').subscribe(res => {
      let cityIds = new Set();
      res.data.rows.forEach(item => {
        delete item['latitude'];
        delete item['longitude'];
        cityIds.add(item.cityId)
      });
      let searchParams = new URLSearchParams();
      searchParams.set('id_In', Array.from(cityIds).toString());
      this.parameterService.getCities(searchParams).subscribe(cityRes => {
        let cities = {};
        cityRes.data.forEach(item => {
          cities[item.id] = item.name
        })
        this.saveAsXlsx(res.data.rows, printPropertyOrders, cities)
      })
    })
  }

  saveAsXlsx(exportHotels, printPropertyOrders, cities) {
    let jsonToExport = [];
    exportHotels.forEach((row) => {
      let newRow = {};
      printPropertyOrders.forEach((key, i) => {
        switch (i + 1) {
          case 1:
            newRow[key] = row.id;
            break;
          case 2:
            newRow[key] = row.name;
            break;
          case 3:
            newRow[key] = row.stars;
            break;
          case 4:
            newRow[key] = row.address;
            break;
          case 5:
            newRow[key] = cities[row.cityId];
            break;
          case 6:
            newRow[key] = row.countryIso;
            break;
          case 7:
            newRow[key] = row.contactNumbers.phone;
            break;
          case 8:
            newRow[key] = row.email;
            break;
          default:
            newRow[key] = '';
            break;
        }
      });
      jsonToExport.push(newRow);
    });

    console.log(jsonToExport);

    const ws_name = "Sheet 1";
    const wb: XLSX.WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = XLSX.utils.json_to_sheet(jsonToExport);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "binary" });

    function s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
      }
      return buf;
    }

    let title = "Hotels.xlsx";

    saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), title);
    this.showLoading = false;
  }

  downloadFile(data: any, filename: string, header: string[]) {
    const replacer = (key, value) => value === null ? '' : value; //TODO:zgr gereksiz, ucusta da var
    let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(';'));
    csv.unshift(header.join(';'));
    let csvArray = csv.join('\r\n');
    let blob = new Blob([csvArray], { type: 'application/octet-stream' });
    saveAs(blob, filename);
  }



}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/main/pages/system-hotels/system-hotels.component.ts